import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { CanvasLayoutDataService } from 'src/app/submodules/angular-common/canvas-layout-data.service';
import { EnvironmentDataService } from '../../../../submodules/angular-common/environment-data.service';
import { RoutingDataService } from '../../../../submodules/angular-common/routing-data.service';
import { BaseView } from '../../../../submodules/angular-ui-common/base-view';
import { LocaleDataService } from '../../../angular-common/locale-data.service';
import { SecurityDataService } from '../../../angular-common/security-data.service';

@Component({
  selector: 'app-public-area-header',
  templateUrl: './public-area-header.component.html',
  styleUrls: ['./public-area-header.component.scss']
})
export class PublicAreaHeaderComponent extends BaseView {

  logoClick = (event) => {this._injector.get(Router).navigate(['/']);}

  constructor(
    public localeDataService: LocaleDataService,
    public canvasLayoutDataService: CanvasLayoutDataService,
    public routingDataService: RoutingDataService,
    public securityDataService: SecurityDataService,
    protected _injector: Injector
  ) {
    super(_injector);
  }

  public loginClick(){
    if(
      this._injector.get(EnvironmentDataService).environment.getValue('federatedLogin')==false
      && this._injector.get(EnvironmentDataService).environment.getValue('mockUserProfile')==false
    )
      this._injector.get(Router).navigate(['/private'])
    else
      this._injector.get(SecurityDataService).login()
  }

  public logoutClick(){
    this._injector.get(SecurityDataService).logout()
  }

  public contactUsClick(){
    this._injector.get(Router).navigate(['/home'],{ fragment: 'form' })
  }

}
